import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

/** Routes that render their own full-width lobby and want no desktop rail. */
const FULL_WIDTH = ['/casino', '/live-casino', '/slots', '/qtech'];

const CasinoLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { pathname } = useLocation();

  // Game lobbies are grids that want the whole viewport; the sports rail next to
  // them just squeezes a column out. Fantasy (also under this layout) keeps it.
  const hideDesktopRail = FULL_WIDTH.some((p) => pathname.startsWith(p));

  return (
    <div>
      <Header onMenuClick={() => setIsSidebarOpen(true)} />

      <div className="flex min-h-screen">
        <Sidebar
          isOpen={isSidebarOpen}
          onToggle={() => setIsSidebarOpen(false)}
          hideDesktopRail={hideDesktopRail}
        />

        <main className="flex-1 overflow-x-hidden">
          <Outlet />
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default CasinoLayout;
